module.exports = __webpack_public_path__ + "static/img/document-icon.6e85cafa.svg";